export const createClosing = obj => ({
    investmentFund: `/api/investment_funds/${obj.fundId}`,
    premium: obj.premium,
    comment: obj.number,
    issueDate: obj.date,
});

export const updateClosing = obj => ({
    id: obj.id,
    ...createClosing(obj),
});
